import { Button, Container, Grid, TextField } from "@material-ui/core"
import { isNullOrEmpty } from "modules/app/reactComponents/packing/sanitization-steps/components/presentation/validationsFunctions"
import { isNotNullOrEmpty } from "modules/utils/isNotNullOrEmpty"
import React from "react"
import 'tailwindcss-styles.dist.css'

export type VerifyEmailPhoneProps = {
    email?:string
    phone?:string
    onConfirm: () => void
    codesSent?:boolean
    onVerify: ({emailCode, phoneCode}:{emailCode:string, phoneCode:string}) => void
}

export const VerifyEmailPhone = (props: VerifyEmailPhoneProps) => {

    const [emailCode, setEmailCode] = React.useState<string>("")
    const [phoneCode, setPhoneCode] = React.useState<string>("")
    
    return <div className="_flex _justify-center _items-center _min-h-screen">

        <div className="_bg-white _rounded-2xl _p-4" style={{
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}>
            <Grid container spacing={2}>

                {isNotNullOrEmpty(props.email) && <Grid item xs={12}>
                        Email: {props.email}
                </Grid>}

                {isNotNullOrEmpty(props.phone) && <Grid item xs={12}>
                    Telefone: {props.phone}
                </Grid>}

                <Grid item xs={12}>
                    <Button color="primary" variant="contained"
                        onClick={() => {
                            if (confirm(`Confirma o envio dos códigos de verificação ?`)) {
                                props.onConfirm()
                            }
                        }}
                        >
                        Enviar códigos de verificação
                    </Button>
                </Grid>

                {isNotNullOrEmpty(props.email) && <Grid item xs={12}>
                    <TextField
                        label="Código de verificação recebido via email"
                        fullWidth
                        value={emailCode}
                        onChange={e => setEmailCode(e.target.value)}
                        />
                </Grid>}
                

                {isNotNullOrEmpty(props.phone) && <Grid item xs={12}>
                    <TextField
                        label="Código de verificação recebido via SMS"
                        fullWidth
                        value={phoneCode}
                        onChange={e => setPhoneCode(e.target.value)}
                        />
                </Grid>}

                {props.codesSent && <Grid item xs={12}>
                    Códigos enviados. Aguarde alguns instantes e verifique os códigos recebidos
                </Grid>}

                {props.codesSent && <Grid item xs={12}>
                    <Button color="primary" variant="contained"
                        onClick={() => {

                            if (isNotNullOrEmpty(props.email) && isNullOrEmpty(emailCode)) {
                                alert(`Informe o código de verificação recebido via email`)
                                return
                            }

                            if (isNotNullOrEmpty(props.phone) && isNullOrEmpty(phoneCode)) {
                                alert(`Informe o código de verificação recebido via SMS`)
                                return
                            }

                            props.onVerify({
                                emailCode: isNotNullOrEmpty(emailCode) ? emailCode : undefined,
                                phoneCode: isNotNullOrEmpty(phoneCode) ? phoneCode : undefined
                            })
                        }}
                        >
                        Verificar códigos
                    </Button>
                </Grid>}
            </Grid>
        </div>


    </div>
}